import * as React from "react";
import {Icon} from "../../../hiberUiKit/src/atoms/Icon/Icon";
import DropDown from "../../../hiberUiKit/src/molecules/DropDown/DropDown";
import InfoModule from "../../../hiberUiKit/src/molecules/InfoModule/InfoModule";
import {Option} from "ts-option";

interface ComponentProps {
	/**
	 * Update custom field value action.
	 * @param {string} updatedValue
	 */
	updateCustomFieldValue: (updatedValue: string) => void;
	/**
	 * Remove custom field value action.
	 */
	removeCustomFieldValue: () => void;
	/**
	 * Custom field values list
	 */
	items: string[]
	/**
	 * Custom field label
	 */
	label: string;
	/**
	 * Selected custom field value
	 */
	selectedValue: Option<string>;
}

export default class EnumDisplay extends React.PureComponent<ComponentProps> {
	render() {
		return (
			<InfoModule icon={Icon.New} title={this.props.label}>
				<DropDown items={this.props.items}
						  itemToId={(item: string) => item}
						  itemToLabel={(item: string) => item}
						  selectedItemId={this.props.selectedValue.orNull}
						  placeholder={'Please select'}
						  onSelect={this.onSelect}
						  clearable
						  onClearClick={this.onClearClick}/>
			</InfoModule>
		)
	}

	onSelect = (value: string) => {
		this.props.updateCustomFieldValue(value);
	};

	onClearClick = () => {
		this.props.removeCustomFieldValue();
	}
}